import {
  Box,
  HStack,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
} from '@chakra-ui/react';
import { FC, ReactNode } from 'react';
import { indigoColors } from '~/common/theme/indigo.colors';
import { ListingChat } from './ListingChat';

interface ListingChatModalWrapperProps {
  isOpen: boolean;
  onClose: () => void;
  initialPrompt?: string;
  refContent?: ReactNode;
}

export const ListingChatModalWrapper: FC<ListingChatModalWrapperProps> = ({
  isOpen,
  onClose,
  initialPrompt,
  refContent,
}) => {
  return (
    <Modal
      isCentered
      isOpen={isOpen}
      size={{ base: 'full', md: '4xl' }}
      onClose={onClose}
    >
      <ModalOverlay />
      <ModalContent bg="transparent" boxShadow="none">
        <ModalBody px={0} py={0}>
          <HStack spacing={0}>
            {refContent && (
              <Box
                bg="blackAlpha.900"
                borderLeftRadius="lg"
                borderRight={`1px solid ${indigoColors.whiteAlpha[100]}`}
                flex={4}
                height="60vh"
                p={6}
              >
                {refContent}
              </Box>
            )}
            <Box
              borderLeftRadius={refContent ? 'none' : 'lg'}
              borderRightRadius="lg"
              flex={5}
              overflow="hidden"
            >
              <ListingChat initialPrompt={initialPrompt} onClose={onClose} />
            </Box>
          </HStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
